<template >
  <splash></splash>
  <div class="container mt-4" dir="rtl">

  <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="card card-body card-panel-box border-0" style="    margin: 1vw .9vw;">
        <center>
          <div class="d-flex justify-content-between">
            <p style="font-size: 1.5vw">
              ماتریس ارتباطات/شرکت {{$route.params.title}} </p>
            <button class="btn btn-primary btn-submit-1" @click="$router.go(-1)">برگشت</button>

          </div>
          <hr>
          <br>
        </center>

         <div class="d-flex flex-nowrap ">
           <div class="card p-4 w-50">
             <center>
               <p style="font-weight: bold; font-size: 1.3vw;">ماتریس ارتباطات درونی  </p>
               <br>
               <router-link class="btn btn-submit-1 btn-info w-50" :to="`/Matrix_Connections/include/by/${$route.params.title}/${$route.params.id}`">تکمیل اطلاعات / بروزرسانی</router-link>
             </center>
           </div>
           <div class="card p-4 w-50 mx-2">
             <center>
               <p style="font-weight: bold; font-size: 1.3vw;">ماتریس ارتباطات بیرونی  </p>
               <br>
               <router-link class="btn btn-submit-1 btn-info w-50" :to="`/Matrix_Connections/exit/by/${$route.params.title}/${$route.params.id}`">تکمیل اطلاعات / بروزرسانی</router-link>
             </center>
           </div>
         </div>
        <br>




      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from "@/components/Sidebar/Sidebar";
import splash from "@/components/Splash/Splash";
import router from "@/router";

export default {
  name: 'HomeView',
  components: {
    Sidebar,
    splash
  },
  methods:{
    checkIsMother(){
      if (!this.is_mother){
        router.push('/pishkhan')
      }

    }
  },
  mounted() {
    this.checkIsMother()
  }
}
</script>
